var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 241,
    viewBox: "0 0 241 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_61_373)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.2821,
    cy: 51.2821,
    r: 51.2821,
    transform: "matrix(0.898853 0.438251 0.438251 -0.898853 52 144.19)",
    fill: "#206E92",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.2821,
    cy: 51.2821,
    r: 48.2655,
    transform: "matrix(0.898853 0.438251 0.438251 -0.898853 52 144.19)",
    stroke: "#3295A8",
    strokeWidth: 6.03319
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.97437,
    cy: 8.97437,
    r: 8.26212,
    transform: "matrix(0.898853 0.438251 0.438251 -0.898853 108.57 124.704)",
    fill: "#3295A8",
    stroke: "#24B9E2",
    strokeWidth: 1.4245
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_61_373",
    x: 0.899643,
    y: 0.899277,
    width: 239.34,
    height: 239.34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.1881,
    result: "effect1_foregroundBlur_61_373"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBlue);
export default __webpack_public_path__ + "static/media/star-blue.cb9057b628ce79c4e34e8595f7d4ba35.svg";
export { ForwardRef as ReactComponent };